import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import '../../css/2fa.css';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';

const Register2Fa = () => {
  const [qrCode, setQrCode] = useState('');
  const [secret, setSecret] = useState('');
  const [userToken, setUserToken] = useState('');
  const navigate = useNavigate();
  const [verificationMessage, setVerificationMessage] = useState('');
  const token = getToken();

  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');

  useEffect(() => {
    generate2FA();
  }, []);

  // Function to handle the 2FA generation
  const generate2FA = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/generate-2fa`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
      console.log(response.data);
      if (response.data.success === 0) {
        notification.error({ message: 'You already enabled 2FA' });
      }
      setQrCode(response.data.qr_code);
      setSecret(response.data.secret);
    } catch (error) {
      console.error('Error generating 2FA:', error);
    }
  };

  // Function to handle the 2FA token verification
  const handleVerify2FA = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/api/users/enable-2fa`,
        {
          userToken,
          secret,
        },
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      if (response.data.success) {
        notification.success({ message: '2FA Verified successfully!' });
        setVerificationMessage('2FA Verified successfully!');
        navigate('/dashboard');
      } else {
        notification.error({ message: 'Invalid token!, try again' });

        setVerificationMessage('Invalid token!, try again');
      }
    } catch (error) {
      console.error('Error verifying 2FA:', error);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="col-md-6 p-4 border rounded shadow-lg bg-light">
        {/* Company Logo */}
        <div className="text-center mb-4">
          {companyLogo && (
            <img
              src={`${API_URL}/${companyLogo}`}
              alt="Company Logo"
              style={{
                maxWidth: '100%',
                maxHeight: '100px',
                objectFit: 'contain',
              }}
            />
          )}
        </div>

        <h2 className="text-center mb-4">{companyName}</h2>
        <h2 className="text-center mb-4">Google Authenticator 2FA</h2>

        {/* <button onClick={handleGenerate2FA}>Generate 2FA QR Code</button> */}

        {qrCode && (
          <div
            className="text-center"
            style={{ width: '100%', maxWidth: '600px' }}
          >
            <h2>Scan this QR code with your Google Authenticator:</h2>
            <img
              src={qrCode}
              alt="QR Code"
              style={{
                width: '100%', // Make the image responsive
                height: 'auto', // Maintain aspect ratio
                maxWidth: '300px', // Limit max width to 400px
                maxHeight: '300px', // Limit max height to 400px
                display: 'block',
                margin: '0 auto',
              }}
              className="qr-code-image "
            />
          </div>
        )}

        <div className="text-center">
          <form onSubmit={handleVerify2FA}>
            <div className="input-group">
              <input
                type="text"
                autoFocus
                placeholder="Enter token  Authenticator"
                value={userToken}
                onChange={(e) => setUserToken(e.target.value)}
                width={'100%'}
                className="form-control"
              />
              <button className="btn btn-primary" type="submit">
                Verify 2FA
              </button>
            </div>
          </form>
          <br />
          <button
            className="btn btn-danger"
            type="button"
            onClick={() => navigate('/dashboard')}
          >
            Ignore 2FA
          </button>
        </div>

        {verificationMessage && <p>{verificationMessage}</p>}
      </div>
    </div>
  );
};

export default Register2Fa;
